export const isInAppBrowser = () => {
  // On iOS window.mobileApp is set after page load, before that we can rely on window.webkit
  // "preShowScriptSuccess" specifically is a handler injected by our inappbrowser plugin

  return (
    !!window?.webkit?.messageHandlers?.preShowScriptSuccess ||
    !!window.mobileApp
  )
}

export const closeInAppBrowser = () => {
  window.mobileApp?.close()
}
async function waitForNativeMessage(type) {
  return new Promise(resolve => {
    let isResolved = false
    function resolveMatchingMessage(event) {
      const message = event?.detail?.message
      if (message?.type === type && !isResolved) {
        isResolved = true
        window.removeEventListener("messageFromNative", resolveMatchingMessage)
        resolve(message)
      }
    }
    window.addEventListener("messageFromNative", resolveMatchingMessage)
  })
}

export const fetchAccessTokenFromNative = async () => {
  if (!window.mobileApp) await waitForNativeMessage("webviewLoaded")
  window.mobileApp?.postMessage({ detail: { message: "requestToken" } })
  return waitForNativeMessage("accessTokenUpdated")
}

export default {
  isInAppBrowser,
  closeInAppBrowser,
  fetchAccessTokenFromNative
}
